import script from "./ExportDashboardModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ExportDashboardModal.vue?vue&type=script&setup=true&lang=js"

import "./ExportDashboardModal.vue?vue&type=style&index=0&id=53ec8b22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53ec8b22"]])

export default __exports__